import { graphql } from "gql.tada";

export const GetRootNavigationItem = graphql(
  `
    query GetRootNavigationItem(
      $locale: String
      $preview: Boolean
      $allowedChildren: Int = 10
    ) {
      navigationItemCollection(
        preview: $preview
        where: { title: "Root Navigation" }
        limit: 1
      ) {
        items {
          __typename
          title(locale: $locale)
          itemsCollection(limit: $allowedChildren, locale: $locale) {
            items {
              __typename
              ...NavigationElementFields
              ... on NavigationItem {
                title(locale: $locale)
                itemsCollection(limit: $allowedChildren, locale: $locale) {
                  items {
                    __typename
                    ...NavigationElementFields
                    ... on NavigationItem {
                      title(locale: $locale)
                    }
                  }
                }
              }
            }
          }
          menuAccessibilityLabel(locale: $locale)
        }
      }
    }

    fragment NavigationElementFields on NavigationItemItemsItem {
      ... on NavigationElement {
        slug(locale: $locale)
        pageTitle(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
    }
  `
);
